import DiscoveryBadge from './DiscoveryBadge';

export default DiscoveryBadge;
